<template>
    <div class="scan-graphic d-flex flex-column justify-content-center align-items-center">
        <i v-if="scanIsBusy" class="fa-duotone fa-spinner fa-spin fa-10x text-primary"></i>
        <i v-else class="fa-duotone fa-scanner fa-10x"></i>
        <div class="display-4 mt-4 text-muted">Scan Package to Begin</div>
        <b-button size="lg" class="mt-5" variant="warning" @click="$router.push({path: '/intake/not-found/'})"><i class="fa-duotone fa-search fa-fw"></i>Search For Order</b-button>
    </div>
</template>

<script>
    import {BROADCAST_CONNECTED} from '@/store/actions';

    export default {
        name: 'intake-scan',
        data() {
            return {
                scanIsBusy: false,
            };
        },
        mounted() {
            this.$barcodeScanner.init((rawBarcode) => {
                this.$barcodeScanner.parseBarcode(rawBarcode, barcode => {
                    this.scanIsBusy = true;
                    this.$router.push({path: '/intake/view/' + encodeURIComponent(barcode)});
                });
            });
        },
        beforeDestroy() {
            this.$barcodeScanner.destroy();
        },
    };
</script>

<style scoped>
    i.fa-10x {
        font-size: 18rem;
        color: gray;
    }

    .scan-graphic {
        height: 75vh;
    }
</style>
